<template>
  <div class="table">
    <div class="table__header" :style="{ gridTemplateColumns: gridTemplate }">
      <span
        v-for="(header, index) in computedHeaders"
        :key="`header-${header.key}-${index}`"
        class="table__header__cell"
      >
        {{ header.text }}
      </span>
    </div>
    <div class="table__body">
      <div
        v-for="(item, i) in items"
        :key="`row-${item.key}-${i}`"
        :style="{ gridTemplateColumns: gridTemplate }"
        class="table__body__row"
        @click="onClickRow(item)"
      >
        <span
          v-for="(header, j) in computedHeaders"
          :key="`cell-${header.key}-${j}`"
          class="table__body__row__cell"
        >
          <span
            v-if="header.key !== 'index'"
            class="table__body__row__cell-name"
          >
            {{ header.text }}
          </span>
          <span class="table__body__row__cell-value">
            <slot :name="header.key" :item="item">
              {{
                header.key === "index" ? `#${i + 1}` : item[header.key] || ""
              }}
            </slot>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VTable",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    withIndex: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedHeaders() {
      const headers = [...this.headers];
      if (this.withIndex) {
        headers.unshift({
          key: "index",
          text: "№",
          width: "50px",
        });
      }
      return headers;
    },
    gridTemplate() {
      return this.computedHeaders.map((item) => item.width || "1fr").join(" ");
    },
  },
  methods: {
    onClickRow(item) {
      this.$emit("on-click-row", item);
    },
  },
};
</script>

<style scoped lang="scss">
.table {
  width: 100%;

  &__header {
    display: grid;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #787878;
    padding: 18px 13px;
    column-gap: 5px;
  }

  &__body {
    display: grid;
    row-gap: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 18.9px;
    color: #ffffff;

    &__row {
      display: grid;
      padding: 18px 13px;
      border: 1px solid #1a1a1a;
      border-radius: 10px;
      column-gap: 5px;
      cursor: pointer;
      transition: 0.3s all ease-in-out;

      &:hover {
        border-color: var(--brand);
      }

      &__cell {
        overflow: hidden;
        text-overflow: ellipsis;

        &-name {
          display: none;
          color: #787878;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .table {
    &__header {
      display: none;
    }

    &__body {
      &__row {
        display: flex;
        flex-direction: column;
        gap: 5px;

        &__cell {
          display: flex;
          gap: 10px;

          span:first-child {
            text-align: left;
          }

          &-name {
            display: flex;
            flex: 1;
          }

          &-value {
            flex: 3;
            text-align: right;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-word;
          }
        }
      }
    }
  }
}
</style>
